import { EluveError, EluveErrorArgs } from './eluve-error';
import { LogLevel } from './types';

export class ApiError extends EluveError {
  readonly name = 'ApiError';
  readonly logLevel: LogLevel = 'error';

  constructor(message = 'API request failed', args?: EluveErrorArgs) {
    super(message, args);
  }
}
